import React from 'react';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';
import { archiveJobDescription } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const ArchiveJobDescriptionForm = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { onResponse, onError, closeArchiveJobDescriptionModal } = useBiopharmaGroupActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const title = biopharmaGroupState?.archiveJobDescription?.title || 'this job description';

  const handleSubmit = () => {
    archiveJobDescription({
      onResponse,
      onError,
      body: {
        authenticityToken,
        archiveJobDescription: biopharmaGroupState?.archiveJobDescription,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to archive <strong>{title}</strong>? This action is not reversible. Archived job descriptions are permanently hidden from the pipeline and this listing.
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeArchiveJobDescriptionModal()}
          >
            Cancel
          </Button>
          <Button type="submit" variant="destructive">
            Archive Job Description
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default ArchiveJobDescriptionForm;
